export enum FIREBASE_AUTH_ERROR_CODE {
    acount_already_exists = 'auth/account-exists-with-different-credential',
    email_already_in_use = 'auth/email-already-in-use',
    expired_action_code = 'auth/expired-action-code',
    invalid_action_code = 'auth/invalid-action-code',
    invalid_email = 'auth/invalid-email',
    network_request_failed = 'auth/network-request-failed',
    user_not_found = 'auth/user-not-found',
    wrong_password = 'auth/wrong-password',
}
